<template>
	<div>
        <div class="row">
            <el-card class="pb-2 pt-3" shadow="always" :body-style="{ padding: '0px'}" style="width:100%;">
             
                <div class="row">
                    <div class="col-md-2">
                        <el-button size="mini" @click="$router.push('/performance-report/sales-losses')"><i class="fa fa-angle-left"></i></el-button>
                    </div>
                    <div class="col-md-8"><h4 class="text-center">PROFIT & LOSS</h4></div>
                    <div class="col-md-2 text-right">
                        <el-button size="mini" @click="toggleFullscreen"><i :class="[toggleIcon ? 'fa-compress' : 'fa-arrows-alt', 'fa']"></i></el-button>
                        <el-button size="mini" @click="$router.push('/performance-report/revenue-and-laba')"><i class="fa fa-angle-right"></i></el-button>
                    </div>
                </div>

                <div class="col-md-12">
                    <el-tabs v-model="activeName" @tab-click="handleTabClick">
                        <el-tab-pane name="0">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>KONSOLIDASI</b></span>
                            <div>
                                <KeuanganKonsolidasiTabContent :showchart="showchart1"/>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="1">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>FUEL</b></span>
                            <div>
                                <KinerjaFinancialFuelTabContent :showchart="showchart2" :tabName="'fuel'" :category="'FUEL'"/>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="2">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>NON FUEL</b></span>
                            <div>
                                <KinerjaFinancialFuelTabContent :showchart="showchart3" :tabName="'non_fuel'" :category="'NON FUEL'"/>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="3">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>KSO</b></span>
                            <div>
                                <KinerjaFinancialFuelTabKSOContent :showchart="showchart4" :tabName="'kso'" :category="'KSO'"/>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane name="4">
                            <span slot="label"><i class="fa fa-gas-pump"></i>&nbsp;&nbsp;<b>BRIGHT</b></span>
                            <div>
                                <KinerjaFinancialFuelTabContent :showchart="showchart5" :tabName="'bright'" :category="'BRIGHT'"/>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>

            </el-card>
    </div>
        
    </div>
</template>

<script>
import KinerjaKeuangan from '@/components/page/KinerjaKeuangan.js'
import KeuanganKonsolidasiTabContent from '@/views/pages/LaporanKinerja/ProfitAndLaba/KeuanganKonsolidasiTabContent.vue'
import KinerjaFinancialFuelTabContent from '@/views/pages/LaporanKinerja/ProfitAndLaba/KinerjaFinancialFuelTabContent.vue'
import KinerjaFinancialFuelTabKSOContent from '@/views/pages/LaporanKinerja/ProfitAndLaba/KinerjaFinancialFuelTabKSOContent.vue'

export default
{
	extends: KinerjaKeuangan,
	components: { 
        KeuanganKonsolidasiTabContent,
        KinerjaFinancialFuelTabContent,
        KinerjaFinancialFuelTabKSOContent
		//ReportParamSelect,
	},

	data() {
		return {
            activeName: '0',

            showchart1: true,
            showchart2: true,
            showchart3: true,
            showchart4: true,
            showchart5: true,
        }
    },
    watch: {

	}, 
    mounted() {
        this.$emit('childrenRoute');

        if(!this.isLocalPeriodSet()) {
            console.log('period is not set')
            //this.$router.push('/performance-report/')
            //this.$route.go('/performance-report/')
        } else {
            console.log('period set')
        }
    },
    methods: {
        handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/

            if(tabName == '0') {
                this.showchart1 = false
                setTimeout(() => {
                    this.showchart1 = true
                }, 500);
            } else if(tabName == '1') {
                this.showchart2 = false
                setTimeout(() => {
                    this.showchart2 = true
                }, 500);
            } else if(tabName == '2') {
                this.showchart3 = false
                setTimeout(() => {
                    this.showchart3 = true
                }, 500);
            } else if(tabName == '3') {
                this.showchart4 = false
                setTimeout(() => {
                    this.showchart4 = true
                }, 500);
            } else if(tabName == '4') {
                this.showchart5 = false
                setTimeout(() => {
                    this.showchart5 = true
                }, 500);
            }
        },
    },
}
</script>